import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
// import persist from '@alpinejs/persist'
import setupData from './data'

window.Alpine = Alpine;

// Initialize Plugins
// Alpine.plugin(persist);
Alpine.plugin(collapse);

// Set up data
setupData();

// Let's Go!
Alpine.start();